(function () {
  'use strict';
  if (window.okhomesEqualCardsBound) return;
  window.okhomesEqualCardsBound = true;
  let scheduled = false;
  let lastWidth = window.innerWidth;
  function equalize() {
    scheduled = false;
    const groups = new Map();
    document.querySelectorAll('.okhomes-listing-card .okhomes-property-summary--card').forEach(box => {
      if (!box.getClientRects().length) return;
      const grid = box.closest('ul') || box.closest('.grid');
      if (!grid) return;
      if (!groups.has(grid)) groups.set(grid, []);
      groups.get(grid).push(box);
    });
    const all = [...groups.values()].flat();
    all.forEach(box => { box.style.height = ''; });
    const heights = [...groups.entries()].map(([grid, boxes]) => [boxes, Math.ceil(Math.max(...boxes.map(box => box.getBoundingClientRect().height)))]);
    heights.forEach(([boxes, height]) => {
      if (height > 0) boxes.forEach(box => { box.style.height = height + 'px'; });
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(equalize);
  }
  function start() {
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.matches('.okhomes-listing-card') || node.querySelector('.okhomes-listing-card'))
      ))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', () => {
      if (Math.abs(window.innerWidth - lastWidth) > 1) {
        lastWidth = window.innerWidth;
        schedule();
      }
    }, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts?.ready) document.fonts.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
